<div class="flex flex-col gap-3 p-8">
  <h1>Customer identity admin</h1>
  <p class="max-text-block-width">
    Overview of the Customer identity realm and available management options.
  </p>
  <section class="grid grid-cols-2 gap-5 mt-5">
    @if (canManageRealms()) {
      <ep-card clickable variant="raised" [routerLink]="['attributes']">
        <div slot="title" class="flex items-center gap-2">
          <svg class="icon icon--medium" viewBox="0 -960 960 960" fill="currentColor">
            <path
              d="M680-280q25 0 42.5-17.5T740-340q0-25-17.5-42.5T680-400q-25 0-42.5 17.5T620-340q0 25 17.5 42.5T680-280Zm0 120q31 0 57-14.5t42-38.5q-22-13-47-20t-52-7q-27 0-52 7t-47 20q16 24 42 38.5t57 14.5ZM480-80q-139-35-229.5-159.5T160-516v-244l320-120 320 120v227q-19-8-39-14.5t-41-9.5v-147l-240-90-240 90v188q0 47 12.5 94t35 89.5Q310-290 342-254t71 60q11 32 29 61t41 52q-1 0-1.5.5t-1.5.5Zm200 0q-83 0-141.5-58.5T480-280q0-83 58.5-141.5T680-480q83 0 141.5 58.5T880-280q0 83-58.5 141.5T680-80ZM480-494Z"
            />
          </svg>
          <h6>Realm attributes</h6>
        </div>
        <p class="clamp-text clamp-text--two-lines">
          Manage custom attributes for the Keycloak realm unavailable from the main admin UI
        </p>
      </ep-card>
    }
    @if (canQueryClients()) {
      <ep-card clickable variant="raised" [routerLink]="['clients']">
        <div slot="title" class="flex items-center gap-2">
          <svg class="icon icon--medium" viewBox="0 -960 960 960" fill="currentColor">
            <path
              d="M240-160q-33 0-56.5-23.5T160-240q0-33 23.5-56.5T240-320q33 0 56.5 23.5T320-240q0 33-23.5 56.5T240-160Zm240 0q-33 0-56.5-23.5T400-240q0-33 23.5-56.5T480-320q33 0 56.5 23.5T560-240q0 33-23.5 56.5T480-160Zm240 0q-33 0-56.5-23.5T640-240q0-33 23.5-56.5T720-320q33 0 56.5 23.5T800-240q0 33-23.5 56.5T720-160ZM240-400q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm240 0q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm240 0q-33 0-56.5-23.5T640-480q0-33 23.5-56.5T720-560q33 0 56.5 23.5T800-480q0 33-23.5 56.5T720-400ZM240-640q-33 0-56.5-23.5T160-720q0-33 23.5-56.5T240-800q33 0 56.5 23.5T320-720q0 33-23.5 56.5T240-640Zm240 0q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Zm240 0q-33 0-56.5-23.5T640-720q0-33 23.5-56.5T720-800q33 0 56.5 23.5T800-720q0 33-23.5 56.5T720-640Z"
            />
          </svg>
          <h6>Clients</h6>
        </div>
        <p class="clamp-text clamp-text--two-lines">
          Manage all clients available to you in the Customer identity instance
        </p>
      </ep-card>
    }
    @if (canQueryUsers()) {
      <ep-card clickable variant="raised" [routerLink]="['users']">
        <div slot="title" class="flex items-center gap-2">
          <svg class="icon icon--medium" viewBox="0 -960 960 960" fill="currentColor">
            <path
              d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z"
            />
          </svg>
          <h6>Users</h6>
        </div>
        <p class="clamp-text clamp-text--two-lines">
          Manage all users available to you in the Customer identity instance
        </p>
      </ep-card>
    }
    @if (canQueryGroups()) {
      <ep-card clickable variant="raised" [routerLink]="['groups']">
        <div slot="title" class="flex items-center gap-2">
          <svg class="icon icon--medium" viewBox="0 -960 960 960" fill="currentColor">
            <path
              d="M40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm720 0v-120q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v120H760ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z"
            />
          </svg>
          <h6>Groups</h6>
        </div>
        <p class="clamp-text clamp-text--two-lines">
          Manage all groups available to you in the Customer identity instance
        </p>
      </ep-card>
    }
  </section>
</div>
